import { LEAD_ACCEPTANCE } from '_constants';
import { LOGIN } from '../constants/login.constants';

export const leadAcceptance = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case LEAD_ACCEPTANCE.ACTION.UPDATE_LEAD_ACCEPTANCE:
      newState.contact = action.value[0];
      newState.opportunity = action.value[1];
      newState.appointment = action.value[2];
      break;
    case LEAD_ACCEPTANCE.ACTION.SET_LEAD_ACCEPTANCE:
      newState.contact = action.contact;
      newState.appointment = action.activeAppointment;
      newState.opportunity = action.activeOpportunity;
      break;
    case LEAD_ACCEPTANCE.ACTION.ACCEPTED_LEAD:
      newState = {};
      break;
    case LOGIN.LOGOUT:
      newState = {};
      break;
    default:
      break;
  }
  return newState;
};
